import styled from "styled-components";
import Text from "antd/es/typography/Text";

export const MoneyCurrency = styled(Text)`
  font-style: normal;
  font-size: 12px;
  font-family:"Inter Bold";
  color: #000000;
`;